// ---------------------------------------------------------------------------
// Onboarding copy - the strings shared by the guest-trial composer surfaces
// (marketing hero + bottom CTA), the docs/invite/error footers, and legal links.
//
// The old /product landing strings that used to live here were removed with the
// /product page (Jun 2026 copy canon) - marketing copy now lives in
// `@/modules/marketing/constants`.
// ---------------------------------------------------------------------------

// Header actions (legacy names kept for the shared auth surfaces).
export const LANDING_TRY_NAUMU = 'Try Naumu';
export const LANDING_SIGN_IN = 'Sign in';

// Footer links (docs / invite / error footers).
export const FOOTER_LINKS = [
	{ label: 'Docs', href: '/docs' },
	{ label: 'Privacy', href: '/legal/privacy-policy' },
	{ label: 'Terms', href: '/legal/terms-of-service' },
];

export type OnboardingChip = { id: string; label: string; prompt: string };

export const ONBOARDING_CHIPS: readonly OnboardingChip[] = [
	{
		id: 'tech-product',
		label: 'Tech product',
		prompt: "I'm building a tech product - need to keep features, my team, and the roadmap in one place. Help me set it up.",
	},
	{
		id: 'wedding',
		label: 'My wedding',
		prompt: "I'm planning our wedding. Venues, vendors, the guest list, and a pile of little tasks to track. Help me organize it.",
	},
	{
		id: 'dance-studio',
		label: 'Dance studio',
		prompt: "I run a dance studio - classes, instructors, students, monthly bills. Too many spreadsheets. Help me sort it out.",
	},
	{
		id: 'marketing-agency',
		label: 'Marketing agency',
		prompt: "I run a marketing agency - juggling clients, campaigns, deliverables, and my team. Help me see it all in one place.",
	},
] as const;

// Typewriter placeholder suggestions (landing hero + CTA)
export const PLACEHOLDER_SUGGESTIONS = [
	"I'm working on a new tech product and need to connect everything - competitors, features, personas, here's my brief: notion.so/startup-plan",
	"I'm organising our wedding in September and need to keep track of venues, vendors, guest lists, everything. Let's start with that",
	"I'm running a marketing agency and can't keep track of all our campaigns, and who's working on what. Let's map it out",
	"Our company wiki is a mess, help me make sense of it: docs.google.com/d/team-knowledge-base",
	"I'm planning a dance studio launch - so many moving parts, from instructors to schedules to marketing",
	"I'm working on a research project and need to connect all my sources, findings, and hypotheses. That's a good starting point",
] as const;

// Legal links (used by landing footer)
export const SIGNIN_TERMS_HREF = '/legal/terms-of-service';
export const SIGNIN_TERMS_LABEL = 'Terms';
export const SIGNIN_PRIVACY_HREF = '/legal/privacy-policy';
export const SIGNIN_PRIVACY_LABEL = 'Privacy';

// Input limits
export const INPUT_MAX_LENGTH = 1000;
